// "Invoice to a company" fields: show/hide, keep the values in the cart as they
// are typed (the cart drawer re-renders), and check the CUI's control digit.
(() => {
  // Romanian CUI/CIF: 2–10 digits, optional "RO"; the last digit is a control
  // digit over the others with the key 753217532.
  function cuiValid(raw) {
    const value = String(raw).toUpperCase().replace(/\s+/g, '').replace(/^RO/, '');
    if (!/^\d{2,10}$/.test(value)) return false;
    const digits = value.slice(0, -1).padStart(9, '0').split('').map(Number);
    const key = [7, 5, 3, 2, 1, 7, 5, 3, 2];
    let control = (digits.reduce((sum, digit, i) => sum + digit * key[i], 0) * 10) % 11;
    if (control === 10) control = 0;
    return control === Number(value.slice(-1));
  }
  window.aqCuiValid = cuiValid;

  const timers = new WeakMap();
  function save(root) {
    clearTimeout(timers.get(root));
    timers.set(
      root,
      setTimeout(() => {
        const toggle = root.querySelector('[data-aq-invoice-toggle]');
        const attributes = {
          'Factura pe firma': toggle.checked ? 'Da' : '',
          Firma: toggle.checked ? root.querySelector('[name="attributes[Firma]"]').value.trim() : '',
          CUI: toggle.checked ? root.querySelector('[name="attributes[CUI]"]').value.trim().toUpperCase() : '',
        };
        fetch(root.dataset.updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes }),
        }).catch(() => {});
      }, 400)
    );
  }

  function init(root) {
    if (root.dataset.aqReady) return;
    root.dataset.aqReady = 'true';
    const toggle = root.querySelector('[data-aq-invoice-toggle]');
    const fields = root.querySelector('[data-aq-invoice-fields]');
    const cui = root.querySelector('[data-aq-cui]');
    const msg = root.querySelector('[data-aq-cui-msg]');

    toggle.addEventListener('change', () => {
      fields.hidden = !toggle.checked;
      // Disabled inputs are not submitted with the checkout form, so an unticked
      // box cannot send an old company name or CUI with the order.
      fields.querySelectorAll('input').forEach((input) => {
        input.disabled = !toggle.checked;
      });
      if (toggle.checked) fields.querySelector('input')?.focus();
      save(root);
    });
    fields.addEventListener('input', () => save(root));
    cui.addEventListener('blur', () => {
      const value = cui.value.trim();
      const bad = value !== '' && !cuiValid(value);
      msg.textContent = bad ? cui.dataset.invalidText : '';
      cui.setAttribute('aria-invalid', String(bad));
    });
  }

  window.aqInvoiceInit = init;
  const start = () => document.querySelectorAll('[data-aq-invoice]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // Dawn re-renders the cart drawer after changes.
  new MutationObserver(start).observe(document.documentElement, { childList: true, subtree: true });
})();
